import React, { useEffect, useState } from 'react';
import '../../assets/css/Formation/FormationPage.css';
import { API_BASE_URL } from '../../utils/config';

function FormationPage() {
    const [formations, setFormations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/formations/`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Erreur lors du chargement des formations");
                }
                return response.json();
            })
            .then((data) => {
                setFormations(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des formations:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []);

    return (
        <div className="formation-page container my-5">
            <p className="introduction-text">
                Découvrez nos formations de secourisme adaptées à tous : du grand public aux professionnels.
                Apprenez les gestes qui sauvent et engagez-vous pour la sécurité de tous.
            </p>

            {loading ? (
                <div className="row formation-loader">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="col-md-6 mb-4">
                            <div className="formation-placeholder">
                                <div className="formation-placeholder-title"></div>
                                <div className="formation-placeholder-text"></div>
                                <div className="formation-placeholder-text"></div>
                                <div className="formation-placeholder-text"></div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : error ? (
                <p className="text-danger text-center">{error}</p>
            ) : (
                <div className="row">
                    {formations.length > 0 ? (
                        formations.map((formation) => (
                            <div key={formation.id} className="col-md-6 mb-4">
                                <div className="formation-card no-image">
                                    <div className="formation-content">
                                        <h5 className="formation-title">{formation.nom}</h5>
                                        <p className="formation-description">
                                            {formation.description_courte}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">Aucune formation disponible pour le moment.</p>
                    )}

                    {/* Tuile supplémentaire "Envie de vous former ?" */}
                    <div className="col-md-6 mb-4">
                        <div className="formation-card special-card">
                            <div className="formation-content text-center">
                                <h5 className="formation-title">Envie de vous former ?</h5>
                                <p className="formation-description">
                                    Contactez-nous pour en savoir plus sur nos formations et choisir celle qui vous convient le mieux !
                                    Nous vous guiderons dans votre parcours de formation en fonction de vos besoins et disponibilités.
                                </p>
                                <a
                                    href="/nous-contacter"
                                    className="btn btn-success mt-2"
                                >
                                    Nous contacter
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FormationPage;
